import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M3 3v18h18V3H3zm8 16H5v-6h6v6zm0-8H5V5h6v6zm8 8h-6v-6h6v6zm0-8h-6V5h6v6z"
}), 'BorderAll');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/BorderAll.js
// module id = 2408
// module chunks = 2